'use strict';

import request from 'superagent';
import api from './core';

export function emptyProcess() {
    return {
        name: '',
        steps: []
    };
}

export function emptyState() {
    return {
        name: '',
        deletable: true,
        document_types: [],
        timeout: 0,
        email_subject: '',
        email_body: ''
    };
}

export function create(process) {
    return api.forwardResult(
        api.prepare(request.post(api.url('/processes/'))).send(process),
        'id'
    );
}

export function update(process) {
    const id = encodeURIComponent(process.id);
    return api.forwardResult(
        api.prepare(request.put(api.url(`/processes/${id}/`))).send(process),
        'id'
    );
}

export function fetch(id) {
    return api.forwardResult(api.prepare(request.get(api.url(`/processes/${id}/`))), 'id');
}

export function fetchPage(page = 1) {
    return api.prepare(request.get(api.url('/processes/'))).query({page});
}

export function list(page = 1) {
    return api.forwardResult(fetchPage(page), 'results');
}

export async function listAll() {
    let next = 1;
    const out = [];

    while (next) {
        const page = (await fetchPage(next)).body;

        if (page.next) {
            next += 1;
        } else {
            next = false;
        }

        out.push(...page.results);
    }

    return out;
}



// WEBPACK FOOTER //
// ./src/api/processes.js